import React, { useState } from 'react'
import { t, Trans } from '@lingui/macro'

import { Modal } from '../../../components/common/modal/Modal'
import { ButtonClean, ButtonPrimary } from 'front-end/src/components'
import Input from '../../../components/common/form/input/Input'
import Form, { FormRow } from '../../../components/common/form/Form'
import Label from '../../../components/common/form/label/Label'

import { ITheme } from '../../../../../types/Series'
import { useEditThemeModalMutation } from './EditThemeModal.codegen'

export interface IEditThemeProps {
  workspaceId: number
  theme: ITheme<any>
  resolve: () => void
  reject: () => void
}

export const EditThemeModal: React.FC<IEditThemeProps> = (props) => {
  const [title, setTitle] = useState(props.theme.title)
  const { reject, theme } = props
  const [editTheme, { loading }] = useEditThemeModalMutation()

  return (
    <Modal
      onHide={reject}
      header={t`Edit ${(theme && theme.title) || ''} theme`}
      controls={
        <>
          <ButtonClean onClick={reject}>
            <Trans>Cancel</Trans>
          </ButtonClean>
          <ButtonPrimary
            disabled={!title}
            onClick={async () => {
              await editTheme({
                variables: {
                  workspaceId: props.workspaceId,
                  themeId: props.theme.id,
                  title
                }
              })
              props.resolve()
            }}
            isLoading={loading}
          >
            <Trans>Edit</Trans>
          </ButtonPrimary>
        </>
      }
    >
      <Form>
        <FormRow>
          <Label htmlFor={''}>
            Title
            <Trans>Title</Trans>
          </Label>
          <Input
            autoFocus
            value={title}
            onChange={(val) => {
              setTitle(val)
            }}
            fullWidth
          />
        </FormRow>
      </Form>
    </Modal>
  )
}
